import { render, staticRenderFns } from "./pogs-roles.vue?vue&type=template&id=5f829bd9&scoped=true&"
import script from "./pogs-roles.vue?vue&type=script&lang=js&"
export * from "./pogs-roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f829bd9",
  null
  
)

export default component.exports